import script from "./CsForecast.vue?vue&type=script&setup=true&lang=js"
export * from "./CsForecast.vue?vue&type=script&setup=true&lang=js"

import "./CsForecast.vue?vue&type=style&index=0&id=8665fdbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8665fdbc"]])

export default __exports__